import { render, staticRenderFns } from "./multipleChoice.vue?vue&type=template&id=f7015488&scoped=true"
import script from "./multipleChoice.vue?vue&type=script&lang=ts"
export * from "./multipleChoice.vue?vue&type=script&lang=ts"
import style0 from "./multipleChoice.vue?vue&type=style&index=0&id=f7015488&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7015488",
  null
  
)

export default component.exports